import React from 'react';
import loader from './loader.svg';

const MediumPreLoader = () => (
  <div className="loader-container">
    <div>
      <div className="loader">
        <div className="loader-icon spinning-cog loader-icon-md">
          <img alt="Загрузка" src={loader} />
        </div>
      </div>
    </div>
  </div>
);
export default MediumPreLoader;



// WEBPACK FOOTER //
// ./src/components/Common/PreLoaders/MediumPreLoader.js